/* eslint-disable */
import React, { useState } from "react";
import { Card, Typography, Box, useTheme, styled, Container, Grid } from "@mui/material";
import JoditEditor from "jodit-react";
import { useLocation } from "react-router";

export const SectionWrapper = styled("section")(({ theme }) => ({
  minHeight: "calc(100vh - 64px)",
  backgroundColor: theme.palette.background.default,
  paddingBottom: "80px",
  "& .representsPage": {
    "& .representsHeading": {
      fontSize: "20px",
      fontWeight: 700,
      lineHeight: "25.2px",
      textAlign: "center",
      color: theme.palette.text.primary,
    },
    "& .representTopBox": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "30px",
      "@media screen and (max-width:600px)": {
        flexDirection: "column",
        gap: "20px",
      },
    },
    "& .BtnGroup": {
      display: "flex",
      justifyContent: "center",
      gap: "16px",
      textAlign: "center",
      "@media screen and (max-width:600px)": {
        flexDirection: "column",
      },
      "& .moreTitle": {
        border: `1px solid ${theme.palette.primary.main}`,
        color: theme.palette.primary.main,
        backgroundColor: "transparent",
        padding: "12px 28px",
        fontSize: "14px",
        fontWeight: 600,
        lineHeight: "17.64px",
        "&.Mui-disabled": {
          color: "#ffffff52",
        },
        "& svg": {
          fill: theme.palette.primary.main,
          marginRight: "8px",
        },
      },
    },
    "& .ContentEditWrapper": {
      "& .jodit-react-container": {
        "& .jodit-container": {
          backgroundColor: "transparent",
          "& .jodit-toolbar__box": {
            backgroundColor: "transparent",
            borderBottom: "none",
            "& .jodit-icon": {
              stroke: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
              fill: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
            },
            "& .jodit-toolbar-button__button": {
              "&:hover:not([disabled])": {
                backgroundColor: theme.palette.primary.main + "2b",
              },
            },
            "& .jodit-toolbar-button__trigger": {
              "& svg": { fill: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547" },
              "&:hover:not([disabled])": {
                backgroundColor: theme.palette.primary.main + "2b",
              },
            },
          },
          "& .jodit-workplace": {
            backgroundColor: "transparent",
            "& .jodit-wysiwyg": {
              "& *": {
                color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
              },
            },
          },
          "& .jodit-status-bar": {
            backgroundColor: "transparent",
            "& .jodit-status-bar__item": {
              "& *": {
                color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
              },
            },
          },
        },
      },
    },
  },
  "& .fourthStep": {
    "& .welcomeCardBox": {
      display: "none",
    },
    "& .showCompleteContent": {
      display: "none",
    },
    "& section .MuiContainer-root": {
      padding: 0,
    },
  },
}));
function BlogEdit() {
  const location = useLocation();
  const { blog } = location.state;
  const [content, setContent] = useState(blog?.blogContent);
  const theme = useTheme();
  return (
    <SectionWrapper>
      <Container maxWidth="">
        <Box sx={{ flexGrow: 1 }}>
          <Card sx={{ padding: "18px 14px 18px 14px", border: `1px solid ${theme.palette.divider}`, boxShadow: "none !important" }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box className="representsPage">
                  <Box className="representTopBox">
                    <Typography className="representsHeading" component="h2">
                      Choose a title that best represents your page.
                    </Typography>
                  </Box>
                  <Box className="ContentEditWrapper">
                    <JoditEditor value={content} onChange={newContent => setContent(newContent)} tabIndex={1} />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Card>
        </Box>
      </Container>
    </SectionWrapper>
  );
}

export default BlogEdit;
